import React from 'react';
import { Button } from "./button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "./card";
import { Shield, GitPullRequest, Check } from "lucide-react";

interface GitHubInstallPromptProps {
  installUrl: string;
}

const GitHubInstallPrompt: React.FC<GitHubInstallPromptProps> = ({ installUrl }) => {

    const handleInstallClick = () => {
        // Track when user clicks to install the GitHub app
        window.gtag('event', 'github_app_install_click', {
            destination: installUrl,
            timestamp: new Date().toISOString(),
            referrer: document.referrer || 'direct'
          });
      };

  return (
    <Card className="w-full max-w-2xl mx-auto">
      <CardHeader>
        <CardTitle className="text-xl font-semibold flex items-center gap-2">
          <Shield className="w-5 h-5 text-blue-500" />
          Connect Your GitHub Repositories
        </CardTitle>
        <CardDescription>
          One last step to get started with myInstantAPI
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="space-y-3">
            <h3 className="font-medium">What this integration does:</h3>
            <ul className="space-y-2">
              <li className="flex items-start gap-2">
                <Check className="w-5 h-5 text-green-500 mt-0.5" />
                <span>Monitor selected repositories for API updates</span>
              </li>
              <li className="flex items-start gap-2">
                <Check className="w-5 h-5 text-green-500 mt-0.5" />
                <span>Automatically deploy API changes when you push updates</span>
              </li>
              <li className="flex items-start gap-2">
                <Check className="w-5 h-5 text-green-500 mt-0.5" />
                <span>Create and store your API backend code in your GitHub</span>
              </li>
            </ul>
          </div>
          
          <div className="text-sm text-gray-500">
            We only request the permissions needed to handle API deployments. We keep the minimum data required to manage and deploy your selected APIs. You can review and modify access settings at any time.
          </div>
        </div>
      </CardContent>
      <CardFooter>
        <Button asChild size="lg" className="w-full sm:w-auto">
          <a href={installUrl} className="inline-flex items-center gap-2" onClick={handleInstallClick}>
            <GitPullRequest className="w-4 h-4" />
            Install GitHub Integration
          </a>
        </Button>
      </CardFooter>
    </Card>
  );
};

export default GitHubInstallPrompt;